import React, { useEffect, useState, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import $ from 'jquery';
import authService from '../../Common/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Joi from '@hapi/joi'
import { RevenueSharedPaymentCalculationSchemaObject } from '../RevenueSharedPaymentCalculationSchema';
import { validateProperty, validate } from "../../Common";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Autocomplete from '@material-ui/lab/Autocomplete';
import tokenService from "../../../Common/tokenDecoder";
import _, { set } from 'lodash';
import { yellow } from '@material-ui/core/colors';

//import { LoadingSpinerComponent } from '../../../Common/loader'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { CommonDecryptParam } from "../../../../utils/CommonParams";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Grid } from '@material-ui/core';
import { AlertDialog } from '../../../Common/AlertDialog';

const screenCode = 'REVENUESHAREDPAYMENTCALCULATION';
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    },
    root: {
        flexGrow: 1,
        backgroundColor: "#fffff",
    },
    rootx: {
        display: "flex",
        "& > * + *": {
            marginLeft: theme.spacing(5),
        },
    },

    bar: {
        backgroundColor: "#424242",
    },
    txt: {
        color: "#ffffff",
        backgroundColor: "#424242",
    },
    paper: {
        backgroundColor: "#424242",
    },

    large: {
        width: theme.spacing(20),
        height: theme.spacing(20),
    },
    title: {
        fontSize: 14,
    },
    card1: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        paddingInlineStart: "10px",
        borderRadius: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
        maxHeight: 1000,
        height: 1000,
    },
    card2: {
        borderRadius: "10px",
        backgroundColor: "#fffff",
        paddingInlineStart: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

        height: 150,
    },

    card3: {
        borderRadius: "10px",
        backgroundColor: "#fffff",
        paddingInlineStart: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

        height: 150,
    },
    card4: {
        borderRadius: "10px",
        backgroundColor: "#fffff",
        paddingInlineStart: "10px",
        boxShadow: " 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",

        height: 250,
    },
    centertitle: {
        color: "#000000",
        fontSize: 30,
        textAlign: "center",
    },

    profImage: {
        paddingLeft: "50px",
    },
    centertitleCurrency: {
        fontSize: 30,
        textAlign: "center",
        color: "#000000",
    },
}));

export function RevenueSharedPaymentCalculation(props) {

    const classes = useStyles();
    const [openDialog, setOpenDialog] = React.useState(false);
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState([]);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [errors, setErrors] = useState({})
    const [finalData, setFinalData] = useState([])
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });
    const [istableHidden, setIstableHidden] = useState(true);
    const [attendance, setAttendance] = useState([]);
    const [paymentListModel, setPaymentListModel] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const handleClose = () => {
        // setSupplierBio({});
        setOpenDialog(false);
    };
    // //POPUp start
    const [message, setMessage] = useState("Edit Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    // //popUP end
    const contentRowNames = ["employeeID", "cardNumber", "inTime", "outTime"]

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    const [DailyAttendance, setDailyAttendance] = useState({
        groupID: '0',
        estate: '0',
        divisionID: '0',
        date: "",
        registrationNumber: "",
        harvesting: '0',
        weedCondition: '',
        conditionType: '0',
        isActive: true
    });

    const schema = Joi.object(RevenueSharedPaymentCalculationSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getAllGroups();
    }, []);

    useEffect(() => {
        if (DailyAttendance.groupID != 0 || DailyAttendance.groupID != "") {
            getEstatesForDropdown();
        }
    }, [DailyAttendance.groupID]);

    useEffect(() => {
        trackPromise(getDivisionsForDropDown());
    }, [DailyAttendance.estate]);


    function handleGroupChange(target) {
        validateInputs(target);

        setDailyAttendance({
            ...DailyAttendance,
            groupID: target.value,
            estate: '0',
            divisionID: '0'
        })
    }

    //POPUP function
    async function handleDelete() {
        setEnableConfirmMessage(true);
    }
    function confirmData(y) {
        if (y) {
            // onCancelClick();
        }
    }

    //popUP End
    function handleEstateChange(target) {
        validateInputs(target);

        setDailyAttendance({
            ...DailyAttendance,
            estate: target.value,
            divisionID: '0'
        })
    }

    function handleDivisionChange(target) {
        //validateInputs(target);

        setDailyAttendance({
            ...DailyAttendance,
            divisionID: target.value,
        });
    }

    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value


        const error = { ...errors }
        const errorMessage = validateProperty(target, RevenueSharedPaymentCalculationSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setDailyAttendance({
            ...DailyAttendance,
            [e.target.name]: value
        })

        setErrors(error)
    }

    function handleChange1(e, accountID) {
        
        const value = e.value
        const name = e.name
        //validateInputs(target);

        const newArr = [...attendance];
        var idx = newArr.findIndex(e => e.accountID == parseInt(accountID));
        newArr[idx] = { ...newArr[idx], [name]: value, isDefault : true};
        setAttendance(newArr)


        // const error = { ...errors }
        // const errorMessage = validateProperty(target, RevenueSharedPaymentCalculationSchemaObject)
        // errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        // setErrors(error)
    }


    function handleDateChange(target) {
        validateInputs(target);

        setDailyAttendance({
            ...DailyAttendance,
            date: target.value
        })
    }
    function handleChangeTypes(target, accountID) {
        const value = target.value
        const name = target.name
        //validateInputs(target);

        const newArr = [...attendance];
        var idx = newArr.findIndex(e => e.accountID == parseInt(accountID));
        newArr[idx] = { ...newArr[idx], [name]: value == "" ? parseFloat(0) : parseFloat(value), isDefault : true };
        setAttendance(newArr)

        // setDailyAttendance({
        //     ...DailyAttendance,
        //     harvesting: target.value
        // })
    }
    function handleWeedConditonChange(target) {
        //validateInputs(target);

        setDailyAttendance({
            ...DailyAttendance,
            weedCondition: target.value
        })
    }
    function handleConditionTypeChange(target) {
        //validateInputs(target);

        setDailyAttendance({
            ...DailyAttendance,
            conditionType: target.value
        })
    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, RevenueSharedPaymentCalculationSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);

    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWREVENUESHAREDPAYMENTCALCULATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        getAllGroups();

    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    async function getAllGroups() {
        var data
        data = await groupService.getGroupsForDropdown();
        setGroups(data)
    }

    async function getEstatesForDropdown() {
        var data
        data = await services.getEstatesByGroupID(DailyAttendance.groupID);
        setEstates(data)
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(DailyAttendance.estate);
        setDivisions(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, DailyAttendance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const response = await services.getPaymentCalculationData(DailyAttendance.groupID, DailyAttendance.estate, DailyAttendance.divisionID, DailyAttendance.registrationNumber, DailyAttendance.date);

        response.forEach(x => {
            x.employeeCode = x.employeeCode;
            x.firstName = x.firstName;
            x.registrationNumber = x.registrationNumber;
            x.targetValue = x.targetValue;
            x.totalAmount = x.totalAmount;
        });
        
        setIstableHidden(false);
        //destroyDataTable();
 
        // let lemp2 = _.groupBy(response, 'cardNumber')
        // const finalResult = Object.values(lemp2)

        
        

        // let targetValuetotal = 0;
        // response.forEach(x => {
        //     let cropSum = x.reduce(function(prev, current) {
        //         return  prev + +current.targetValue
        //       }, 0);
        //       x.totalTarget = cropSum;
        //     // x.forEach(y => {
        //     //     targetValuetotal += (y.targetValue);
        //     // });

        // });
        // let cropTotal = 0;
        // response.forEach(x => {
        //     let targetSum = x.reduce(function(prev, current) {
        //         return  prev + +current.totalAmount
        //       }, 0);
        //       x.totalCrop = targetSum;
        //     // x.forEach(y => {
        //     //     cropTotal += (y.totalAmount );
        //     // });

        // });

        response.forEach(x => {
            //x.totalTarget = sum;
            //x.totalCrop = cropTotal;
            
            x.harvestingPercentage = ((x.totalAmount /  x.targetValue) * 100);

        });



        setAttendance(response);


        createDataTable();
    }

    async function paymentDetails() {
        
    }

    async function AddList() {
        setOpenDialog(true)

        //var newResult = attendance;
        var result = [...attendance];
        var result2 = result.filter(x=> x.isDefault == true)
        result2.forEach(x => {
                if(x.harvestingPercentage >= 80 && x.weedCondition >= 80 && x.conditionType == 1){
                    x.payment =  parseFloat(x.totalAmount * 60); 
                  }else if(x.harvestingPercentage < 80 && x.weedCondition >= 80 && x.conditionType == 2){
                      x.payment = parseFloat(x.totalAmount * 55);
                  }else if(x.harvestingPercentage < 80 && x.weedCondition < 80 && x.conditionType == 3){
                      x.payment = parseFloat(x.totalAmount * 40);
                  }else{
                    x.payment = " - "
                  }
           
        
        });
        setFinalData(result2);

    
        // let paymentModel = {
        //     employeeCode: attendance[0].employeeCode,
        //     registrationNumber: attendance[0].registrationNumber,
        //     firstName: attendance[0].firstName,
        //     cardNumber: attendance[0].cardNumber,
        //     harvesting: parseInt(attendance[0].harvesting),
        //     weedCondition: parseInt(attendance[0].weedCondition),
        //     conditionType: parseInt(attendance[0].conditionType),
        //     isActive: DailyAttendance.isActive,
        //     createdBy: tokenService.getUserIDFromToken(),
        //     createdDate: new Date().toISOString(),
        // }


        // setPaymentListModel(paymentListModel => [...paymentListModel, paymentModel]);
        //clearFormFields();
    }


    async function handleSave() {
        setOpenDialog(false)
        destroyDataTable();
        setIstableHidden(true)
       //clearState();
        //let model = {
        //   accountID: parseInt(attendance.accountID),
        //   registrationNumber: attendance.registrationNumber,
        //   employeeCode: attendance.employeeCode,
        //   employeeName: attendance.firstName,
        //   cardNumber: attendance.cardNumber,
        //   harvesting: parseInt(DailyAttendance.harvesting),
        //   weedCondition: parseInt(DailyAttendance.weedCondition),
        //   conditionType: parseInt(DailyAttendance.conditionType),
        //paymentListModel : paymentListModel,
        //   isActive: DailyAttendance.isActive,
        //   createdBy: tokenService.getUserIDFromToken(),
        //   createdDate: new Date().toISOString(),
        //}
        //const response = await services.updatePaymentCalculation(paymentListModel);

        // if (response.statusCode == "Success") {
        //     alert.success('Parameter Added Successfully');
        // }
        // else {

        //     alert.error(response.message);
        // }

    }
    function clearState() {
        setDailyAttendance({
            ...DailyAttendance,
            groupID: "0",
            estate: "0",
            divisionID: "0",
            date: "",
            registrationNumber: ""
        });
        setErrors("");
        //clearTableData();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Revenue Shared Payment Calculation"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Groups"
                            path="groups/addEdit" />
                        <div className="card-body">

                            <form onSubmit={(e) => trackPromise(handleSearch(e))} disabled={false}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={DailyAttendance.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>



                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estate">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estate"
                                            id="estate"
                                            name="estate"
                                            value={DailyAttendance.estate}
                                            onChange={(e) => handleEstateChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estate"] && <FormHelperText error>{errors["estate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">
                                            Division
                                        </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={DailyAttendance.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="date">Month *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="month"
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Registration No"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={DailyAttendance.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["registrationNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>
                                </div>


                                <div className="card-footer">
                                    <input

                                        type="submit"
                                        className="btn btn-primary"
                                        value="Search"
                                    //onClick={e => trackPromise(handleSearch(e))}
                                    />

                                </div>
                            </form>


                            { attendance.length != 0 ? 
                            <div className="table-responsive row-top-gap"
                            hidden={istableHidden}
                            >
                                
                                <div className="table-responsive row-top-gap">
                                
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Emp Code</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Reg No</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Emp Name</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Card Number</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Todate Crop(Kg)</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Target Crop(Kg)</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Harvesting(%)</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Weed Condition(%)</TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Condition Type</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                               
                                                {attendance.slice(page * limit, page * limit + limit).map((row, i) => (
                                                    <TableRow
                                                        key={i}
                                                    >

                                                        <TableCell component="th" scope="row" align="left"> {row.employeeCode}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.registrationNumber}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.firstName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left"> {row.cardNumber}</TableCell>
                                                        <TableCell component="th" scope="row" align="right"> {row.totalAmount.toFixed(2)}</TableCell>
                                                        <TableCell component="th" scope="row" align="right"> {row.targetValue.toFixed(2)}</TableCell>
                                                        <TableCell component="th" scope="row" align="right"> {row.harvestingPercentage.toFixed(2)}</TableCell>
                                                     
                                                        <TableCell component="th" scope="row" align="left">
                                                            <div className="col-md pb-1">
                                                                <TextField fullWidth label="Weed Condition"
                                                                    name="weedCondition"
                                                                    id="weedCondition"
                                                                    value={row.weedCondition == null ? "" : row.weedCondition}
                                                                    type="text"
                                                                    onChange={(e) => handleChange1(e.target, row.accountID)} />
                                                                {errors["weedCondition"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["weedCondition"]}</FormHelperText>}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" align="left">
                                                            <Select
                                                                fullWidth
                                                                labelId="conditionType"
                                                                id="conditionType"
                                                                name="conditionType"
                                                                value={row.conditionType == null ? "0" : row.conditionType}
                                                                onChange={(e) => handleChangeTypes(e.target, row.accountID)}
                                                            >
                                                                <MenuItem value="0">--Condition Type--</MenuItem>
                                                                <MenuItem value="1">Good</MenuItem>
                                                                <MenuItem value="2">Poor</MenuItem>
                                                                <MenuItem value="3">Bad</MenuItem>
                                                            </Select>  </TableCell>

                                                    </TableRow>

                                                )
                                                )}

                                            </TableBody>

                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={attendance.length}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                    </TableContainer>

                                </div>
                                 
                                {/* <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>

                                            <th>EmployeeID</th>
                                            <th>Card number</th>
                                            <th> In time</th>
                                            <th>Out time</th>

                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={attendance}
                                            contentRowNames={contentRowNames}
                                            hasEdit={permissionList.isAddEditEnabled}

                                        />
                                    </tbody>
                                </table> */}
                                <br>
                                </br>
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(AddList(e))}
                                    />
                                </div>
                                {/* <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Update"
                                        onClick={e => trackPromise(handleSave(e))}
                                    />
                                </div> */}

                            </div>
                            : null }
                           
                            <div hidden={true}>
                                <Grid item>
                                    <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                                        discription={"Are you sure want to Edit "} setViewPopup={setEnableConfirmMessage} />
                                </Grid>
                            </div>
                            {/* popUP Start */}
                            <div hidden={true}>
                                <div>

                                    <LoadingSpinerComponent />
                                    <Dialog open={openDialog} onClose={handleClose} maxWidth={true} 
                                        aria-labelledby="form-dialog-title">
                                        <DialogTitle id="form-dialog-title" className={classes.title}><b>Payments</b>{" "}</DialogTitle>
                                        <DialogContent>
                                            <Box>
                                                <TableContainer component={Paper}>
                                                    <Table className={classes.table} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>Emp Code</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>Reg No</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>Emp Name</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: "bold" }}>Card Number</TableCell>
                                                                <TableCell align="right" style={{ fontWeight: "bold" }}>Payment (Rs)</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {finalData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                                <TableRow
                                                                    key={i}
                                                                >

                                                                    <TableCell component="th" scope="row" align="left"> {row.employeeCode}</TableCell>
                                                                    <TableCell component="th" scope="row" align="left"> {row.registrationNumber}</TableCell>
                                                                    <TableCell component="th" scope="row" align="left"> {row.firstName}</TableCell>
                                                                    <TableCell component="th" scope="row" align="left"> {row.cardNumber}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right"> {row.payment == " - " ? " - "  : row.payment.toFixed(2)}</TableCell>
                                                                    

                                                                </TableRow>

                                                            )
                                                            )}

                                                        </TableBody>

                                                    </Table>
                                                    <TablePagination
                                                        component="div"
                                                        count={finalData.length}
                                                        onChangePage={handlePageChange}
                                                        onChangeRowsPerPage={handleLimitChange}
                                                        page={page}
                                                        rowsPerPage={limit}
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                    />
                                                </TableContainer>
                                            </Box>

                                        </DialogContent>
                                        <DialogActions>
                                            <div className="col-md pb-1">
                                            <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Close"
                                                    onClick={handleClose}
                                                />
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Complete"
                                                    onClick={e => trackPromise(handleSave(e))}
                                                />
                                                
                                            </div>
                                                
                                        </DialogActions>
                                    </Dialog>
                                    <Grid item>
                                        <AlertDialog confirmData={confirmData} headerMessage={message}
                                            discription={"Are you sure want to Edit "} />
                                    </Grid>
                                </div>
                            </div>
                            {/* popup end */}
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    )
}


